import { ProcessedSearchResultItem } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import Box from '@redbubble/design-system/src/Box';
import Input from '@redbubble/design-system/src/Form/Input';
import Text from '@redbubble/design-system/src/Text';
import { NodeItem } from 'pages/shop/types';
import React from 'react';
import {
  ListsButtonInventoryItem,
  ListsInclusions,
} from 'types/shop-bff/types';
import { isItemInList } from '../../utils/lists';

interface ListItemProps {
  inventoryItem: ListsButtonInventoryItem | ProcessedSearchResultItem;
  handleCheckbox: (
    listId: string,
    inventoryItemId: string,
    isInList: boolean
  ) => void;
  node?: NodeItem | null;
  listsInclusions?: ListsInclusions | null;
}

const ListItem: React.FC<ListItemProps> = ({
  node,
  listsInclusions,
  inventoryItem,
  handleCheckbox,
}) => {
  const checked = isItemInList(
    node?.listId,
    listsInclusions,
    inventoryItem?.id
  );

  if (!node) return null;

  return (
    <Box
      key={node.listId}
      style={{
        borderTop: '1px solid #d6dadf',
        display: 'block',
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        padding="m"
        onClick={() => {
          handleCheckbox(inventoryItem.id, node.listId, checked);
        }}
        style={{
          cursor: 'pointer',
        }}
      >
        <Box
          display="flex"
          alignItems="flex-start"
          marginRight="xs"
          marginTop="xxs"
          data-testid={`${node.listId}-list-item`}
        >
          <Input
            key={`${node?.name}_${node.listId}`}
            type="checkbox"
            label={node?.name}
            name={node.listId}
            checked={checked}
            readOnly
          />
        </Box>
        <Box display="flex" alignItems="flex-start">
          <Text display="block" type="display6">
            {node?.name}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ListItem;
